import PageContent from '@/layout/PageContent'

const ComingSoon = () => {
    return (
        <PageContent>
            <div>
                <h1 className='font-bold text-3xl text-center'>Coming Soon</h1>
            </div>
        </PageContent>
    )
}

export default ComingSoon
